import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Geography")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "placeholder col-12",
  style: {"height":"300px"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
        : (_ctx.loading && !_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createBlock(_component_apexchart, {
              key: 2,
              type: "bar",
              height: "300",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"]))
    ])
  ]))
}